import image1 from "../../../assets/comparison-blog-images/image_1.jpeg";
import image2 from "../../../assets/comparison-blog-images/image_2.jpeg";
import image3 from "../../../assets/comparison-blog-images/image_3.jpeg";
import image4 from "../../../assets/comparison-blog-images/image_4.jpeg";
import image5 from "../../../assets/comparison-blog-images/image_5.jpeg";

/** Preset cover images for comparison blogs (select in admin, uploaded on save). */
export const COMPARISON_COVER_IMAGES = [
  { id: "image_1", src: image1, label: "Cover 1", fileName: "image_1.jpeg" },
  { id: "image_2", src: image2, label: "Cover 2", fileName: "image_2.jpeg" },
  { id: "image_3", src: image3, label: "Cover 3", fileName: "image_3.jpeg" },
  { id: "image_4", src: image4, label: "Cover 4", fileName: "image_4.jpeg" },
  { id: "image_5", src: image5, label: "Cover 5", fileName: "image_5.jpeg" },
];

/** Fetch a preset asset and return a File suitable for multipart upload. */
export async function fileFromComparisonCover(cover) {
  const res = await fetch(cover.src);
  if (!res.ok) {
    throw new Error(`Failed to load cover image ${cover.id}`);
  }
  const blob = await res.blob();
  return new File([blob], cover.fileName, {
    type: blob.type || "image/jpeg",
  });
}
